// extracted by mini-css-extract-plugin
module.exports = {"deleteAttributeBtn":"AttributeButtons_deleteAttributeBtn_32OGq"};